import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const getAnalyticsApi = async (payload = {}, authHeaders) => {
  try {
    const { operation = 'GET_INTERNAL_WABA_ANALYTICS', ...payloadData } = payload;
    const apiInputData = {
      operation,
      payload: payloadData,
    };

    const res = await apiCallPost(apiPaths.whatsappAnalytics, apiInputData, authHeaders);
    if (res) {
      return { data: res, status: true };
    }
    return { data: {}, status: false, errMsg: 'Failed to fetch analytics' };
  } catch (err) {
    return { status: false, errMsg: err.message };
  }
};
